export default __webpack_public_path__ + "static/media/ProjectBackgroundTwo.9d5d4e16.png";